<template>
    <div class="TopNav">
        <template v-if="!isLoading">
            <div class="TopNav__title-container">
                <StreamlineIcon
                    class="TopNav__page-title-icon"
                    :icon="pageIcon"
                    stroke="#A9B1BD"
                    :size="24"
                />
                <h5 class="TopNav__page-title">
                    {{ activeSection.label }}
                </h5>
            </div>

            <div class="TopNav__nav">
                <RPNavTab
                    v-for="subsection in subsections"
                    :key="subsection.key"
                    class="TopNav__nav-link"
                    :to="subsection.to"
                    :active-tab="activeSubsection.to.name"
                    @navigate="to => $emit('navigate', to)"
                >
                    {{ subsection.label }}
                </RPNavTab>
            </div>

            <slot name="search"></slot>

            <ProfileBar
                :user-profile="userProfile"
                @nav-to-profile="$emit('nav-to-profile')"
                @sign-out="e => $emit('sign-out', e)"
            />
        </template>
    </div>
</template>

<script>
import ProfileBar from './TopNav/ProfileBar.vue';
import RPNavTab from 'components/Basic/Buttons/RPNavTab.vue';
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import navIconHelper from './navIconHelper';
import {Search as SearchIcon} from "@reviewpush/streamline-regular/lib/interface-essential/Search";
import stat from 'status';

export default {
    name: 'RPTopNav',
    components: {
        ProfileBar,
        RPNavTab,
        StreamlineIcon
    },
    props: {
        /**
         * See `RPDashboardLayout` for prop details
         */
        activeSection: {
            type: Object,
            required: true,
        },
        /**
         * See `RPDashboardLayout` for prop details
         */
        subsections: {
            type: Array,
            required: true,
        },
        /**
         * See `RPDashboardLayout` for prop details
         */
        activeSubsection: {
            type: Object,
            required: true,
        },
        /**
         * See `RPDashboardLayout` for prop details
         */
        userProfile: {
            type: Object,
            default: () => ({}),
        },
        status: {
            type: String,
            default: stat.STANDBY
        }
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        pageIcon(){
            return navIconHelper(this.activeSection.icon);
        },
        searchIcon(){
            return SearchIcon;
        }
    }
};
</script>

<style lang="scss">
    .TopNav {
        background: $white;
        color: $grey-600;
        position: relative;
        height: 3.625rem;
        @include shadow("extra-low");
        display: flex;
        align-items: center;
        padding: 0 1rem;

        &__title-container{
            height: inherit;
            display: flex;
            align-items: center;
            padding-right: 1rem;
        }

        &__page-title-icon {
            width: 1.5rem;
            height: 1.5rem;
        }

        &__page-title {
            margin-left: 1rem;
            font-weight: 600;
            color: $grey-500;
        }

        &__nav {
            flex-grow: 1;
            display: flex;
        }
        &__nav-link {
            margin-left: 1.5rem;
        }
    }
</style>

<docs>
```vue
<RPTopNav
    :activeSection="{
        key: 'dashboard',
        label: 'Dashboard',
        icon: 'home',
        to: {
            name: 'Dashboard'
        }
    }"
    :activeSubsection="{
        key: 'link-1',
        label: 'Link 1',
        icon: 'measure',
        to: {
            name: 'Link1'
        }
    }"
    :subsections="[
        {
            label: 'Link 1',
            key: 'link-1',
            to: {name: 'SomeRouteName'}
        },
        {
            label: 'Link 2',
            key: 'link-2',
            to: {name: 'AnotherRouteName'}
        }
    ]"
>
</RPTopNav>
```
</docs>
